import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getK3Agents, setK3Agents } from '../../actions/k3agentAction';
import {
  Button,
  Card,
  Form,
  InputGroup,
  Row,
  Col,
  Badge,
  Spinner,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import { BsSearch, BsPlus, BsFilter, BsFiles, BsCircleFill, BsList, BsCode } from 'react-icons/bs';
import K3AgentCreator from './K3AgentCreator';
import K3AgentView from './K3AgentView';
import K3ModalViewSource from '../../components/K3/K3ModalViewSource';
import qs from 'query-string';

class K3AgentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      k3agents: [],
      searchKeyword: '',
      showCreator: false,
      showViewer: false,
      selectedAgent: null,
      filters: {
        type: '',
        status: '',
        main_type: ''
      },
      sortBy: 'updatedAt',
      sortOrder: 'desc',
      currentPage: 1,
      agentsPerPage: 20,
      showSourceModal: false,
      selectedAgentForSource: null
    };
  }

  componentDidMount() {
    // Parse main_type from URL if present
    const urlFilters = qs.parse(window.location.search);
    if (urlFilters.main_type) {
      this.setState(prev => ({
        filters: {
          ...prev.filters,
          main_type: urlFilters.main_type
        }
      }), () => {
        this.props.getK3Agents(this.getCurrentQuery());
      });
    } else {
      this.props.getK3Agents(this.getCurrentQuery());
    }
  }

  componentDidUpdate(prevProps) {
    // Sync main_type filter with URL if it changes
    if (window.location.search !== this._lastSearch) {
      this._lastSearch = window.location.search;
      const urlFilters = qs.parse(window.location.search);
      this.setState(prev => ({
        filters: {
          ...prev.filters,
          main_type: urlFilters.main_type || ''
        }
      }), () => {
        this.props.getK3Agents(this.getCurrentQuery());
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.k3agents) {
      this.setState({ k3agents: nextProps.k3agents });
    }
  }

  updateUrl = (query) => {
    // Remove empty values
    const cleanQuery = {};
    Object.keys(query).forEach(key => {
      if (query[key] && query[key] !== '') cleanQuery[key] = query[key];
    });
    const queryString = qs.stringify(cleanQuery);
    const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;
    window.history.replaceState(null, '', newUrl);
  }

  getCurrentQuery = () => {
    const { searchKeyword, filters, sortBy, sortOrder, currentPage, agentsPerPage } = this.state;
    return {
      keyword: searchKeyword.trim(),
      ...filters,
      sort_by: sortBy,
      sort_order: sortOrder,
      page: currentPage,
      limit: agentsPerPage
    };
  }

  handleSearch = (e) => {
    e.preventDefault();
    const query = this.getCurrentQuery();
    this.updateUrl(query);
    this.props.getK3Agents(query);
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      }
    }), () => {
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Agents(query);
    });
  };

  handleSortChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Agents(query);
    });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Agents(query);
    });
  };

  handleAgentsPerPageChange = (e) => {
    const agentsPerPage = parseInt(e.target.value);
    this.setState({ agentsPerPage, currentPage: 1 }, () => {
      const query = this.getCurrentQuery();
      this.updateUrl(query);
      this.props.getK3Agents(query);
    });
  };

  handleViewAgent = (agent) => {
    this.setState({
      selectedAgent: agent,
      showViewer: true
    });
  };

  handleCopyAgent = async (agent) => {
    try {
      // Extract number from name if exists
      const nameMatch = agent.name.match(/^(.*?)\s*\((\d+)\)$/);
      let newName;
      if (nameMatch) {
        const baseName = nameMatch[1];
        const number = parseInt(nameMatch[2]) + 1;
        newName = `${baseName} (${number})`;
      } else {
        newName = `${agent.name} (2)`;
      }

      // Create new agent object
      const newAgent = {
        ...agent,
        name: newName,
        status: 'active',
        availability: true
      };

      // Remove fields that should not be copied
      delete newAgent._id;
      delete newAgent.createdAt;
      delete newAgent.updatedAt;

      await this.props.setK3Agents([newAgent]);
      this.props.getK3Agents();
    } catch (error) {
      console.error('Error copying agent:', error);
    }
  };

  getAgentStatus = (agentId) => {
    const agent = this.state.k3agents.find(a => a._id === agentId);
    if (!agent || !agent.last_heartbeat) return null;

    const lastHeartbeat = new Date(agent.last_heartbeat);
    const now = new Date();
    const minutesDiff = Math.floor((now - lastHeartbeat) / (1000 * 60));
    const isOnline = minutesDiff <= 5;

    return {
      isOnline,
      minutesDiff,
      lastHeartbeat: lastHeartbeat.toLocaleString()
    };
  };

  renderAgentStatus = (agentId) => {
    const status = this.getAgentStatus(agentId);
    if (!status) return null;

    const tooltip = (
      <Tooltip>
        Last heartbeat is {status.minutesDiff} minutes ago ({status.lastHeartbeat})
      </Tooltip>
    );

    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <span className="ms-2">
          <BsCircleFill
            color={status.isOnline ? '#28a745' : '#6c757d'}
            size={10}
          />
        </span>
      </OverlayTrigger>
    );
  };

  handleShowSource = (agent) => {
    this.setState({
      selectedAgentForSource: agent,
      showSourceModal: true
    });
  };

  handleHideSource = () => {
    this.setState({
      selectedAgentForSource: null,
      showSourceModal: false
    });
  };

  render() {
    const { k3agents, loading } = this.state;
    const { totalAgents } = this.props;
    const {
      searchKeyword,
      showCreator,
      showViewer,
      selectedAgent,
      filters,
      sortBy,
      sortOrder,
      currentPage,
      agentsPerPage,
      showSourceModal,
      selectedAgentForSource
    } = this.state;

    const totalPages = Math.ceil(totalAgents / agentsPerPage);

    return (
      <div className="container-fluid p-4">
        <Row className="mb-4 align-items-center">
          <Col md={8}>
            <Form onSubmit={this.handleSearch}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search agents..."
                  value={searchKeyword}
                  onChange={(e) => this.setState({ searchKeyword: e.target.value })}
                />
                <Button variant="outline-secondary" type="submit">
                  <BsSearch />
                </Button>
              </InputGroup>
            </Form>
          </Col>
          <Col md={4} className="text-end">
            <Button
              variant="primary"
              onClick={() => this.setState({ showCreator: true })}
            >
              <BsPlus className="me-1" /> New Agent
            </Button>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <Form.Select
              name="main_type"
              value={filters.main_type}
              onChange={this.handleFilterChange}
              className="w-auto"
            >
              <option value="">Main Type</option>
              <option value="HUMAN">Human</option>
              <option value="AI">AI</option>
              <option value="MACHINE">Machine</option>
            </Form.Select>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-muted">
                Found {totalAgents} {totalAgents === 1 ? 'agent' : 'agents'}
              </div>
              <div className="d-flex align-items-center gap-3">
                <span className="me-2">Sort by:</span>
                <Form.Select
                  name="sortBy"
                  value={sortBy}
                  onChange={this.handleSortChange}
                  className="w-auto"
                >
                  <option value="updatedAt">Updated At</option>
                  <option value="createdAt">Created At</option>
                  <option value="name">Name</option>
                  <option value="type">Type</option>
                  <option value="status">Status</option>
                </Form.Select>
                <Form.Select
                  name="sortOrder"
                  value={sortOrder}
                  onChange={this.handleSortChange}
                  className="w-auto"
                >
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </Form.Select>
                <span className="ms-3 me-2">Agents per page:</span>
                <Form.Select
                  value={agentsPerPage}
                  onChange={this.handleAgentsPerPageChange}
                  style={{ width: 'auto' }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Form.Select>
              </div>
            </div>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <Row>
            {k3agents.map(agent => (
              <Col key={agent._id} lg={3} md={4} sm={6} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title className="text-truncate mb-2 d-flex align-items-center" title={agent.name}>
                      <h5 className="me-1 mb-0">{agent.name}</h5>
                      {this.renderAgentStatus(agent._id)}
                    </Card.Title>
                    <div className="small text-muted mb-2">
                      <div>Main Type: {agent.main_type}</div>
                      <div>Sub Type: {agent.sub_type}</div>
                      <div>Status: {agent.status}</div>
                      <div>Availability: {agent.availability ? 'Available' : 'Unavailable'}</div>
                    </div>
                    <div className="mb-3" style={{ minHeight: '24px' }}>
                      {agent.tags?.map(tag => (
                        <Badge pill key={tag} bg="success" className="me-1 mb-1">
                          {tag}
                        </Badge>
                      ))}
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleViewAgent(agent)}
                      >
                        View
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleCopyAgent(agent)}
                      >
                        <BsFiles className="me-1" /> Clone
                      </Button>
                      <Button
                        variant="outline-dark"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleShowSource(agent)}
                      >
                        <BsCode className="me-1" /> Source
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {showCreator && (
          <K3AgentCreator
            show={showCreator}
            onHide={() => this.setState({ showCreator: false })}
          />
        )}

        {showViewer && selectedAgent && (
          <K3AgentView
            show={showViewer}
            onHide={() => this.setState({ showViewer: false, selectedAgent: null })}
            selectedAgent={selectedAgent}
          />
        )}

        <K3ModalViewSource
          show={showSourceModal}
          onHide={this.handleHideSource}
          data={selectedAgentForSource}
          title="Agent Source"
        />

        {totalPages > 1 && (
          <Row className="mt-4">
            <Col>
              <div className="d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => this.handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                      <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => this.handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => this.handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  k3agents: state.k3agentReducer.k3agents,
  loading: state.k3agentReducer.loading,
  totalAgents: state.k3agentReducer.totalAgents
});

export default connect(mapStateToProps, { getK3Agents, setK3Agents })(K3AgentList); 